module.exports = __webpack_public_path__ + "static/media/student-icon.a2fe1343.svg";